import { Skeleton } from '@chakra-ui/react/skeleton'
import { useState } from 'react'

import classes from './styles.module.css'

interface Props {
  src: string
  alt: string
  className?: string
}

export const SkeletonImage = ({ src, alt, className }: Props) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className={classes.wrapper} aria-busy={!loaded}>
      {!loaded && (
        <Skeleton
          className={classes.skeleton}
          role="status"
          aria-label="Загрузка изображения"
        />
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setLoaded(true)}
        style={loaded ? undefined : { display: 'none' }}
      />
    </div>
  )
}
